export type AnalyticsPropertyValue = string | number | boolean;

/** Keep product analytics useful for counts without collecting user-entered or location-specific values. */
export function minimizeAnalyticsProperties(
  eventName: string,
  properties?: Record<string, unknown>,
): Record<string, AnalyticsPropertyValue> {
  const input = properties ?? {};
  const pick = (...keys: string[]) =>
    Object.fromEntries(
      keys.flatMap((key) => {
        const value = input[key];
        return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean'
          ? [[key, value]]
          : [];
      }),
    ) as Record<string, AnalyticsPropertyValue>;

  switch (eventName) {
    case 'page_view':
      return pick('title');
    case 'search':
      return pick('resultCount');
    case 'resource_view':
      return pick('resourceType');
    case 'favorite_toggle':
      return pick('isFavorited');
    case 'location_saved':
      return pick('state');
    case 'resource_shared':
      return pick('method');
    case 'filter_applied':
      return pick('filter');
    case 'view_mode_changed':
      return pick('viewMode');
    case 'geolocation_detected':
      return pick('success');
    default:
      return {};
  }
}
